import React, { useState } from 'react';
import './TenPM.css';
import itstenpm from '../assets/itstenpm.png';

function TenPM() {
  const [formData, setFormData] = useState({
    message: '',
    botcheck: '' // honeypot
  });
  const [status, setStatus] = useState({ state: 'idle', msg: '' });

  async function handleSubmit(e) {
    e.preventDefault();
    if (formData.botcheck) return;

    setStatus({ state: 'submitting', msg: '' });

    try {
      const data = new FormData();
      data.append('access_key', '72c0727f-88c4-4259-8e9a-017e727e592e'); // your Web3Forms key
      data.append('subject', 'New TenPM submission');  // optional
      data.append('from_name', 'wednesdaynightsss.com'); // optional
      data.append('message', formData.message);

      const res = await fetch('https://api.web3forms.com/submit', { method: 'POST', body: data });
      const json = await res.json();

      if (json.success) {
        setStatus({ state: 'success', msg: 'Sent! I got your note. 💌' });
        setFormData({ message: '', botcheck: '' });
      } else {
        setStatus({ state: 'error', msg: json.message || 'Something went wrong. Try again?' });
      }
    } catch {
      setStatus({ state: 'error', msg: 'Network error. Please try again.' });
    }
  }

  return (
    <div className="tenpm-page">
      <img src={itstenpm} alt="itsten" className="tenpm-words" />
      <div className="prawl">
          <h1> i know i purposefully made this anonymous but it's getting annoying please put your name</h1>
      </div>
      <form
        onSubmit={handleSubmit}
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}
      >
        {/* Honeypot (hidden) */}
        <input
          className="hp"
          type="text"
          name="botcheck"
          autoComplete="off"
          tabIndex="-1"
          value={formData.botcheck}
          onChange={(e) => setFormData({ ...formData, botcheck: e.target.value })}
        />

        <textarea
          className="tenpm-textbox"
          name="message"
          placeholder="you could tell me...or you could just come over here instead"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          required
        />

        <button
          type="submit"
          className="tenpm-submit"
          disabled={status.state === 'submitting' || !formData.message.trim()}
        >
          {status.state === 'submitting' ? 'Sending…' : 'Send'}
        </button>

        {status.state === 'success' && <p className="tenpm-success">{status.msg}</p>}
        {status.state === 'error' && <p className="tenpm-error">{status.msg}</p>}
      </form>
    </div>
  );
}

export default TenPM;
